import React, { useEffect, useState } from 'react';
import { Menu, X } from 'lucide-react';
export function Header() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const navLinks = [{
    name: 'Inicio',
    href: '#inicio'
  }, {
    name: 'Nosotros',
    href: '#nosotros'
  }, {
    name: 'Tecnología',
    href: '#tecnologia'
  }, {
    name: 'Servicios',
    href: '#servicios'
  }, {
    name: 'Cobertura',
    href: '#cobertura'
  }];
  return <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-white/95 backdrop-blur-md shadow-sm py-4' : 'bg-transparent py-6'}`} data-id="element-101">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-102">
        <div className="flex justify-between items-center" data-id="element-103">
          {/* Logo */}
          <a href="#inicio" className="z-50" data-id="element-104">
            <img src="https://cdn.magicpatterns.com/uploads/uaZfLQJvdRAZ5JSimEabuc/zumpago.png" alt="Zumpago" className="h-14 w-auto" data-id="element-105" />
          </a>

          {/* Desktop Nav */}
          <nav className="hidden md:flex items-center gap-8" data-id="element-106">
            {navLinks.map(link => <a key={link.name} href={link.href} className={`text-sm font-medium transition-colors hover:text-zumpago-red ${isScrolled ? 'text-gray-600' : 'text-gray-200'}`} data-id="element-107">
                {link.name}
              </a>)}
            <a href="#contacto" className={`px-5 py-2.5 rounded-full text-sm font-semibold transition-all ${isScrolled ? 'bg-zumpago-red text-white hover:bg-red-700' : 'bg-white text-zumpago-dark hover:bg-gray-100'}`} data-id="element-108">
              Contacto
            </a>
          </nav>

          {/* Mobile Menu Toggle */}
          <button className="md:hidden z-50 p-2" onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} data-id="element-109">
            {isMobileMenuOpen ? <X className={isScrolled ? 'text-gray-900' : 'text-white'} data-id="element-110" /> : <Menu className={isScrolled ? 'text-gray-900' : 'text-white'} data-id="element-111" />}
          </button>
        </div>
      </div>

      {/* Mobile Nav */}
      <div className={`fixed inset-0 bg-zumpago-dark z-40 flex flex-col justify-center items-center transition-transform duration-300 ease-in-out ${isMobileMenuOpen ? 'translate-x-0' : 'translate-x-full'} md:hidden`} data-id="element-112">
        <nav className="flex flex-col items-center gap-8" data-id="element-113">
          {navLinks.map(link => <a key={link.name} href={link.href} onClick={() => setIsMobileMenuOpen(false)} className="text-2xl font-medium text-white hover:text-zumpago-red transition-colors" data-id="element-114">
              {link.name}
            </a>)}
        </nav>
      </div>
    </header>;
}